import {type Writable, get} from "svelte/store"

/**
 * Only fires if the event is the same as the current target
 * @param event
 */
export function clickEnterSpecific(this: HTMLElement, event: KeyboardEvent) {
    if (event.key === "Enter" || event.key === " ") {
        if (event.target !== this) return
        event.preventDefault()
        this.click()
    }
}

export function clickEnter(this: HTMLElement, event: KeyboardEvent) {
    if (event.key === "Enter" || event.key === " ") {
        if (this.ariaDisabled) return
        event.preventDefault()
        this.click()
    }
}

export function sliderDirective(
    node: HTMLElement,
    {
        min,
        max,
        valuestore,
        callback,
    }: {
        min: number
        max: number
        valuestore: Writable<number>
        callback?: (number: number) => void
    }
) {
    const increment = (max - min) / 10
    // function ariaUpdater(valuenow : number) {
    //     node.setAttribute("aria-valuenow", valuenow+"")
    // }

    // const unsubscriber = valuestore.subscribe(ariaUpdater)

    function accessibleSliderKeyEvent(event: KeyboardEvent) {
        let sliderValue = get(valuestore)
        event.stopPropagation()
        if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
            sliderValue = Math.max(min, sliderValue - increment)
        } else if (event.key === "ArrowRight" || event.key === "ArrowUp") {
            sliderValue = Math.min(max, sliderValue + increment)
        }

        if (callback) {
            callback(sliderValue)
        } else {
            valuestore.set(sliderValue)
        }
    }

    node.addEventListener("keydown", accessibleSliderKeyEvent)

    return {
        destroy() {
            // unsubscriber()
            node.removeEventListener("keydown", accessibleSliderKeyEvent)
        },
    }
}
